import React from 'react';
import { FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import classes from './ContactIcons.module.css';
import FlexRowDiv from '../UI/FlexRowDiv';

const ContactIcons = () => {
  return (
    <React.Fragment>
      <FlexRowDiv>
        <div className={classes.iconContainer}>
          <FaMapMarkerAlt />
          <p>Newport Beach, California, USA</p>
        </div>
        <div className={classes.iconContainer}>
          <FaEnvelope />
          <p>chat@sbsdevops.com</p>
        </div>
      </FlexRowDiv>
    </React.Fragment>
  );
};

export default ContactIcons;
